import { IDeserializable } from './deserializable';

export class Plan implements IDeserializable {
    Id: string;
    Name: string;
    Price: number;
    ProductId: string;
    CouponId: string;
    /** If this is a discount plan, this object is the plan that contains the regular price */
    BasePlan: Plan;

    deserialize(obj: any) {
        Object.assign(this, obj);
        return this;
    }

}